
module.exports = {
  "bulmaCssVariablesDefs": {
    "link": {
      "calls": [
        {
          "fn": "darken",
          "fnArg": "1000",
          "composeArg": null
        },
        {
          "fn": "rgba",
          "fnArg": "25",
          "composeArg": null
        },
        {
          "fn": "darken",
          "fnArg": "250",
          "composeArg": null
        },
        {
          "fn": "darken",
          "fnArg": "500",
          "composeArg": null
        },
        {
          "fn": "color-invert",
          "fnArg": null,
          "composeArg": null
        },
        {
          "fn": "color-invert",
          "fnArg": null,
          "composeArg": {
            "fn": "darken",
            "fnArg": "500",
            "composeArg": null
          }
        },
        {
          "fn": "color-invert",
          "fnArg": null,
          "composeArg": {
            "fn": "rgba",
            "fnArg": "70",
            "composeArg": null
          }
        },
        {
          "fn": "color-invert",
          "fnArg": null,
          "composeArg": {
            "fn": "rgba",
            "fnArg": "90",
            "composeArg": null
          }
        },
        {
          "fn": "dark-color",
          "fnArg": null,
          "composeArg": null
        },
        {
          "fn": "dark-color",
          "fnArg": null,
          "composeArg": {
            "fn": "lighten",
            "fnArg": "1000",
            "composeArg": null
          }
        },
        {
          "fn": "light-color",
          "fnArg": null,
          "composeArg": null
        },
        {
          "fn": "light-color",
          "fnArg": null,
          "composeArg": {
            "fn": "darken",
            "fnArg": "1000",
            "composeArg": null
          }
        },
        {
          "fn": "light-color",
          "fnArg": null,
          "composeArg": {
            "fn": "darken",
            "fnArg": "250",
            "composeArg": null
          }
        },
        {
          "fn": "light-color",
          "fnArg": null,
          "composeArg": {
            "fn": "darken",
            "fnArg": "500",
            "composeArg": null
          }
        }
      ]
    },
    "primary": {
      "calls": [
        {
          "fn": "darken",
          "fnArg": "1000",
          "composeArg": null
        },
        {
          "fn": "rgba",
          "fnArg": "25",
          "composeArg": null
        },
        {
          "fn": "darken",
          "fnArg": "250",
          "composeArg": null
        },
        {
          "fn": "darken",
          "fnArg": "500",
          "composeArg": null
        },
        {
          "fn": "color-invert",
          "fnArg": null,
          "composeArg": null
        },
        {
          "fn": "color-invert",
          "fnArg": null,
          "composeArg": {
            "fn": "darken",
            "fnArg": "500",
            "composeArg": null
          }
        },
        {
          "fn": "color-invert",
          "fnArg": null,
          "composeArg": {
            "fn": "rgba",
            "fnArg": "70",
            "composeArg": null
          }
        },
        {
          "fn": "color-invert",
          "fnArg": null,
          "composeArg": {
            "fn": "rgba",
            "fnArg": "90",
            "composeArg": null
          }
        },
        {
          "fn": "dark-color",
          "fnArg": null,
          "composeArg": null
        },
        {
          "fn": "dark-color",
          "fnArg": null,
          "composeArg": {
            "fn": "lighten",
            "fnArg": "1000",
            "composeArg": null
          }
        },
        {
          "fn": "light-color",
          "fnArg": null,
          "composeArg": null
        },
        {
          "fn": "light-color",
          "fnArg": null,
          "composeArg": {
            "fn": "darken",
            "fnArg": "1000",
            "composeArg": null
          }
        },
        {
          "fn": "light-color",
          "fnArg": null,
          "composeArg": {
            "fn": "darken",
            "fnArg": "250",
            "composeArg": null
          }
        },
        {
          "fn": "light-color",
          "fnArg": null,
          "composeArg": {
            "fn": "darken",
            "fnArg": "500",
            "composeArg": null
          }
        }
      ]
    }
  }
}
